import React, { Component } from "react";
import "../style.css";
import Table from "../Table/index";
import moment from "moment";
import EmptyState from "../../../../../../../assets/svg/evNoData.svg";

class ChargeEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewIdx: 0,
      filteredReport: this.props.data.history,
    };
  }

  JSONToCSV = () => {
    let reportData = this.props.data.history;
    let str = "";
    let heads = [
      {
        hdg: "Vehicle No",
      },
      {
        hdg: "Chraging Started At",
      },
      {
        hdg: "Start SOC",
      },
      {
        hdg: "Chraging Ended At",
      },
      {
        hdg: "End SOC",
      },
    ];
    let headline = "";
    for (var i = 0; i < heads.length; i++) {
      if (headline != "") headline += ",";
      headline += heads[i]["hdg"];
    }
    str += headline + "\r\n";

    for (let idx in reportData) {
      let line = "";
      if (line != "") line += ",";
      line += reportData[idx].vehicleno;

      str += "\r\n" + line;
      line = "";
      for (let jdx in reportData[idx].chargingevent) {
        if (line != "") line += ",";
        line += ",";
        line +=
          moment(reportData[idx].chargingevent[jdx][0].time).format(
            "DD-MM-YYYY h:mm A"
          ) +
          "," +
          reportData[idx].chargingevent[jdx][0].value +
          "," +
          moment(reportData[idx].chargingevent[jdx][1].time).format(
            "DD-MM-YYYY h:mm A"
          ) +
          "," +
          reportData[idx].chargingevent[jdx][1].value;

        str += line + "\r\n";
        line = "";
      }
      // str+=line+"\r\n";
    }

    var blob = new Blob([str], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, this.getCSVName());
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", this.getCSVName());
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
  getCSVName() {
    let auth = window.auth;
    let date = moment().format("DD-MM-YYYY_Hmm");
    return auth.userinfo.username + "_Charging_Events_" + date + ".csv";
  }

  searchReport(key) {
    let processData = this.props.data.history;
    let filteredReport = [];
    if (key.length >= 2) {
      for (let idx in processData) {
        if (processData[idx].vehicleno.includes(key.toUpperCase())) {
          filteredReport.push(processData[idx]);
        }
      }
      this.setState({ filteredReport: filteredReport });
    } else {
      this.setState({ filteredReport: processData });
    }
  }

  render() {
    return (
      <div
        className={
          "widgetLayout " +
          (this.props.isExpanded === "ct004" ? "expandedWidget " : "")
        }
      >
        <div className="header">
          <div>Charging Events</div>
          <div
            className="rightIcons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: 50,
              alignItems: "center",
            }}
          >
            <i onClick={this.JSONToCSV} className="fa fa-download"></i>

            {this.props.isExpanded == "ct004" ? (
              <i
                onClick={() => this.props.setExpand("ct004")}
                className="fa fa-window-minimize"
              ></i>
            ) : (
              <i
                onClick={() => this.props.setExpand("ct004")}
                className="fa fa-window-maximize"
              ></i>
            )}
          </div>
        </div>
        {this.props.data.distribution > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent:
                this.state.viewIdx === 1 ? "space-between" : "flex-end",
              alignItems: "center",
            }}
          >
            {this.state.viewIdx === 1 ? (
              <div
                className="searchBox"
                style={{
                  marginLeft: 12,
                  marginTop: 9,
                  width: this.props.isExpanded == "ct004" ? 365 : 186,
                }}
              >
                <input
                  type="text"
                  placeholder="search"
                  style={{
                    padding: "3px 8px",
                    borderRadius: 15,
                    width: "100%",
                    border: "1px solid #b1b1b1",
                    fontSize: 11,
                    color: "#4c4a4a",
                  }}
                  onChange={(e) => this.searchReport(e.target.value)}
                />
              </div>
            ) : null}
            <div className="topAction">
              <ul>
                <li
                  onClick={() => this.setState({ viewIdx: 0 }, () => {})}
                  className={this.state.viewIdx === 0 ? "active" : ""}
                >
                  Chart
                </li>
                <li
                  onClick={() => this.setState({ viewIdx: 1 })}
                  className={this.state.viewIdx === 1 ? "active" : ""}
                >
                  Table
                </li>
              </ul>
            </div>
          </div>
        ) : null}
        {this.state.viewIdx === 0 ? (
          <div className="widgetbody">
            {this.props.data.distribution === 0 ? (
              <img style={{ width: 200 }} src={EmptyState} />
            ) : (
              <div className="distribution" id="pieEV" ref="currentlycharging">
                <i
                  className="fa fa-charging-station eventIcon"
                  style={{
                    fontSize:
                      this.props.isExpanded == "ct004" ? "7rem" : "4rem",
                  }}
                ></i>
                <div
                  className="vehCount"
                  style={{
                    fontSize:
                      this.props.isExpanded == "ct004" ? "7rem" : "4rem",
                  }}
                >
                  {this.props.data.distribution}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="tableView">
            <div className="tableContainer">
              {this.state.filteredReport.map((data, key) => {
                return (
                  <div key={key} className="tableBox">
                    <div
                      style={{
                        width: "45%",
                        display: "flex",
                        borderRight: "1px solid #c5c2c2",
                      }}
                    >
                      <div key={key} className="box-events">
                        <div className="container">
                          <div className="label">EVENTS</div>
                          <div className="count">
                            {data.chargingevent.length}
                          </div>
                        </div>
                      </div>
                      <div className="vehicle">{data.vehicleno}</div>
                    </div>
                    <div
                      className="box-right"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <div className="eventLogs">
                        {data.chargingevent.map((event, keys) => {
                          return event.length > 0 ? (
                            <div key={keys} className="eventTime">
                              <div className="time">
                                {moment(event[0].time).format("h:mm A")}{" "}
                                <i
                                  style={{ margin: "0px 5px" }}
                                  className="fa fa-long-arrow-alt-right"
                                ></i>{" "}
                                {moment(event[1].time).format("h:mm A")}
                              </div>
                              <div className="charge">
                                {" "}
                                {event[0].value} - {event[1].value}
                              </div>
                            </div>
                          ) : null;
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {this.state.filteredReport.length === 0 ? (
              <div className="noresultfound">NO RESULT</div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default ChargeEvent;
